<template>
    <div>
        <Language v-model="form.lang" @change="getDetail"></Language>
        <el-form>
            <el-form-item label="标题">{{ form.title }}</el-form-item>
            <el-form-item v-if="form.category == 1" label="收件人">
                <el-tag v-for="item in form.users" :key="item.uuid">{{ item.nick_name }}</el-tag>
            </el-form-item>
            <el-form-item v-if="form.category == 3" label="封面图">
                <img v-for="item in form.cover.split(',')" :key="item" :src="ossUrl + item" style="height: 100px" />
            </el-form-item>
            <el-form-item label="内容">
                <div v-html="form.content"></div>
            </el-form-item>
            <el-form-item v-if="form.category == 1" label="定时发布">{{ form.publish_time }}</el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import { detail } from "@/api/msg/list";
import { ossUrl } from "@/configs/oss";
export default {
    components: { Language },
    data() {
        return {
            ossUrl,
            form: {
                lang: "zh",
            },
            cuuid: "",
        };
    },
    mounted() {
        this.cuuid = this.$route.query.cuuid;
        this.getDetail();
    },
    methods: {
        getDetail() {
            detail({ cuuid: this.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result };
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.cuuid };
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
